import React from "react";
import {mdTheme} from "../../../constants/mdTheme";
import {ThemeProvider} from "@mui/material/styles";
import AuthHeader from "./AuthHeader";
import AuthFooter from "./AuthFooter";
import AuthContent from "./AuthContent";
import Box from "@mui/material/Box";

export const AuthLayout:React.FunctionComponent<any> = ({ children }) => {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100vh', background: '#FAFAFA' }}>
        <AuthHeader/>
        <AuthContent>
          {children}
        </AuthContent>
        <AuthFooter />
      </Box>
    </ThemeProvider>
  )
}

export default AuthLayout